export function isFileError(error: unknown): error is FileError {
    return Object.keys(error as FileError).indexOf('code') > -1;
}
